import { Checkbox, FormControlLabel } from '@mui/material';
import React from 'react';

interface ToggleLineProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    title: string;
    disabled?: boolean;
}

const ToggleLine: React.FC<ToggleLineProps> = ({ checked, onChange, title, disabled = false }) => {
    return (
        <FormControlLabel
            disabled={disabled}
            label={title}
            control={<Checkbox checked={checked} onChange={(_, checked) => onChange(checked)} color="success" />}
            sx={{ padding: '0 5px' }}
        />
    );
};

export default ToggleLine;
